// @flow

import styled from 'styled-components';
import { fonts, colors } from 'shared/styleguide';

export const Branch = styled.div`
  ${fonts.bodyRegular};
  display: flex;
  flex-flow: row nowrap;
  width: 100%;
  height: 100%;
`;

export const ItemNumber = styled.div`
  ${fonts.bodyBold}
  display: flex;
  align-items: center;
  height: 100%;
  vertical-align: middle;
  text-align: center;
  border-right: solid 1px ${colors.lightBlueGrey};
  padding-left: 10px;
  padding-right: 20px;
  margin-right: 16px;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  padding-right: 50px;
  padding-top: 5px;
`;

export const Header = styled.div`
  ${fonts.smallRegular};
  color: ${colors.battleshipGrey};
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding-bottom: 6px;
  display: flex;
  flex-direction: row;

  @media (min-width: 1000px) {
    padding-right: 0;
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  flex-flow: row nowrap;
`;

export const TooltipTitle = styled.div`
  display: block;
  ${fonts.bodyBold};
  padding-bottom: 4px;
  text-transform: uppercase;
`;

export const TooltipContent = styled.div`
  ${fonts.bodyRegular}
  padding-bottom: 12px;
`;

export const BomTypeBadge = styled.span`
  ${fonts.smallRegular};
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 11px;
  text-transform: capitalize;
  background-color: ${props => {
    switch (props.type) {
      case 'engineering':
        return '#e3f2fd';
      case 'manufacturing':
        return '#e8f5e9';
      case 'sales':
        return '#fff3e0';
      case 'service':
        return '#fce4ec';
      case 'configurable':
        return '#ede7f6';
      default:
        return '#f5f5f5';
    }
  }};
  color: ${props => {
    switch (props.type) {
      case 'engineering':
        return '#1565c0';
      case 'manufacturing':
        return '#2e7d32';
      case 'sales':
        return '#ef6c00';
      case 'service':
        return '#c2185b';
      case 'configurable':
        return '#6a1b9a';
      default:
        return '#616161';
    }
  }};
`;

export const PhantomTag = styled.span`
  ${fonts.smallRegular};
  color: ${colors.battleshipGrey};
  font-style: italic;
  margin-left: 4px;
`;

export const BomTypeSelect = styled.select`
  width: 100%;
  padding: 10px 12px;
  border-radius: 4px;
  border: 1px solid ${colors.lightBlueGrey};
  font-size: 14px;
  background: white;
  cursor: pointer;
  ${fonts.bodyRegular};

  &:focus {
    outline: none;
    border-color: ${colors.azul};
  }

  &:hover {
    border-color: ${colors.battleshipGrey};
  }
`;

export const DetailModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

export const DetailModalCard = styled.div`
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  max-width: 600px;
  width: 90%;
  max-height: 80vh;
  overflow-y: auto;
`;

export const DetailModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid ${colors.lightBlueGrey};
`;

export const DetailModalTitle = styled.h2`
  ${fonts.headerBold};
  margin: 0;
  font-size: 18px;
  color: ${colors.charcoalGrey};
`;

export const DetailModalCloseButton = styled.button`
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: ${colors.battleshipGrey};
  padding: 0;
  line-height: 1;

  &:hover {
    color: ${colors.charcoalGrey};
  }
`;

export const DetailModalBody = styled.div`
  padding: 24px;
`;

export const DetailSection = styled.div`
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const DetailSectionTitle = styled.div`
  ${fonts.smallBold};
  color: ${colors.battleshipGrey};
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 8px;
`;

export const DetailRow = styled.div`
  display: flex;
  padding: 8px 0;
  border-bottom: 1px solid ${colors.lightBlueGrey};

  &:last-child {
    border-bottom: none;
  }
`;

export const DetailLabel = styled.div`
  ${fonts.bodyRegular};
  color: ${colors.battleshipGrey};
  width: 160px;
  flex-shrink: 0;
`;

export const DetailValue = styled.div`
  ${fonts.bodyRegular};
  color: ${colors.charcoalGrey};
  flex: 1;
`;
